import React, { useState, useRef, useEffect} from 'react';
import Footer from '../components/footer';
import { createGlobalStyle } from 'styled-components';
import { Link } from '@reach/router';
import AuthService from '../../services/auth.service';

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.sticky.white {
    background: #403f83;
    border-bottom: solid 1px #403f83;
  }
  header#myHeader.navbar .search #quick_search{
    color: #fff;
    background: rgba(255, 255, 255, .1);
  }
  header#myHeader.navbar.white .btn, .navbar.white a, .navbar.sticky.white a{
    color: #fff;
  }
  header#myHeader .dropdown-toggle::after{
    color: rgba(255, 255, 255, .5);
  }
  header#myHeader .logo .d-block{
    display: none !important;
  }
  header#myHeader .logo .d-none{
    display: block !important;
  }
  @media only screen and (max-width: 1199px) {
    .navbar{
      background: #403f83;
    }
    .navbar .menu-line, .navbar .menu-line1, .navbar .menu-line2{
      background: #fff;
    }
    .item-dropdown .dropdown a{
      color: #fff !important;
    }
  }
`;

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};


const Logintwo = (props) => {

    const form = useRef();
    const checkBtn = useRef();
  
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [currentUser, setCurrentUser] = useState(undefined)

    useEffect (()=> {
      const user = AuthService.getCurrentUser();
      console.log("user:" + user + " , " +currentUser)

    if (user) {
      setCurrentUser(user)
    }

    },[])
  
    const onChangeUsername = (e) => {
      const username = e.target.value;
      setUsername(username);
    };
  
    const onChangePassword = (e) => {
      const password = e.target.value;
      setPassword(password);
    };
  
    const handleLogin = (e) => {  
  
      setMessage("");
      setLoading(true);
  
      // form.current.validateAll();
  
      // if (checkBtn.current.context._errors.length === 0) {
      AuthService.login(username, password).then(
        () => {
          // props.history.push("/createOptions");
          window.location.replace("/createOptions")
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
  
          setLoading(false);
          setMessage(resMessage);
        }
      );
      // } else {
      //   setLoading(false);
      // }
    };

    if (!currentUser) {
  
return (
  <div>
    <GlobalStyles />

    <section className='jumbotron breadcumb no-bg' style={{ backgroundImage: `url(${'./img/background/subheader.jpg'})` }}>
      <div className='mainbreadcumb'>
        <div className='container'>
          <div className='row'>
            <div className="col-md-12 text-center">
              <h1>User Login</h1>
              <p>Anim pariatur cliche reprehenderit</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className='container'>
      <div className="row">

        <div className="col-md-6 offset-md-3">

          <div name="contactForm" id='contact_form' className="form-border">
            <Link to='/register'>
              <button className='btn-success text-light mb-2'>Don't have an account? Create a new one here!</button>
            </Link>
            <h3>Login to your account</h3>
            <div className="field-set">
                      <input type='text'
                        name='Username'
                        id='Username'
                        className="form-control"
                        placeholder="Username"
                        value={username}
                        onChange={onChangeUsername}
                        validations={[required]}
                      />

                    </div>

                    <div className="field-set">
                      <input type='password'
                        name='password'
                        id='password'
                        value={password}
                        onChange={onChangePassword}
                        className="form-control"
                        placeholder="Password"
                        validations={[required]}
                      />
                    </div>

                    <div className="field-set">
                      {/* <Link to='/createOptions'> */}
                        <a  id='send_message' className="btn btn-main btn-fullwidth color-2"
                          onClick={() => { handleLogin() }}> Login </a>
                      {/* </Link> */}
                    </div>

                    <div className="clearfix"></div>
                    {message && (
                      <div className="form-group">
                        <div className="alert alert-danger" role="alert">
                          {message}
                        </div>
                      </div>
                    )}
          </div>

        </div>
      </div>
    </section>

    <Footer />
  </div>

);
                    } else{
                      window.location.replace("/createOptions")
                    }
  }
export default Logintwo;